var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.assetIcon)?_c('img',{attrs:{"src":_vm.assetIcon},on:{"error":_vm.handleError}}):_c('avatar',{attrs:{"address":_vm.address,"size":"22"}})}
var staticRenderFns = []

export { render, staticRenderFns }